module.exports = __webpack_public_path__ + "img/Notificaciones.3dadc2cf.png";